module.exports = __webpack_public_path__ + "static/media/camping-keyvisualbg.d4de7bc6.jpg";